// Steam curls up off the cup: each wisp is one S-curve that rises, drifts
// sideways and fades out. No falling particles — this is a hot drink.
const STEAM_WISPS = [
  { x: 14, delay: 0, dur: 5.2, width: 1.4, opacity: 0.34 },
  { x: 27, delay: 1.7, dur: 6.4, width: 1.0, opacity: 0.24 },
  { x: 39, delay: 0.8, dur: 5.8, width: 1.6, opacity: 0.3 },
  { x: 52, delay: 2.6, dur: 6.9, width: 1.1, opacity: 0.2 },
  { x: 64, delay: 0.35, dur: 5.5, width: 1.5, opacity: 0.32 },
  { x: 77, delay: 2.1, dur: 6.2, width: 1.2, opacity: 0.22 },
  { x: 89, delay: 1.2, dur: 5.9, width: 1.3, opacity: 0.26 },
];

// A rising S: leans one way, then back, thinning as it goes.
function wispPath(x) {
  return `M${x} 42 C ${x - 5} 33 ${x + 5} 26 ${x} 17 S ${x - 4} 6 ${x + 1} -4`;
}

export default function AmbianceCoffeeAtmosphere() {
  return (
    <span
      className="mode-tile__atmosphere mode-tile__atmosphere--coffee"
      aria-hidden="true"
    >
      <span className="mode-tile__coffee-noise" />
      <svg
        className="mode-tile__steam-svg"
        viewBox="0 0 100 40"
        preserveAspectRatio="none"
        focusable="false"
      >
        {STEAM_WISPS.map((wisp, index) => (
          <path
            key={index}
            className="mode-tile__steam-wisp"
            d={wispPath(wisp.x)}
            style={{
              strokeWidth: wisp.width,
              "--steam-peak": wisp.opacity,
              animationDelay: `${wisp.delay}s`,
              animationDuration: `${wisp.dur}s`,
            }}
          />
        ))}
      </svg>
    </span>
  );
}
